import React from "react";
import Text, {
  TEXT_FONT_WEIGHT as PRICE_FONT_WEIGHT,
  TEXT_SIZE,
} from "@/bit/components/next13.components.text";

import {
  SEGMENT as TEXT_SEGMENT,
  getNormalizedSegment,
} from "@gerenciatd/next13.enums.segments";

const parsePrice = (
  number,
  decimals,
  decimalChar = ",",
  thousandChar = "."
) => {
  let res = number;
  res = res.toString().replace(",", thousandChar);
  res = parseFloat(res).toFixed(decimals);
  res = res.replace(".", decimalChar);
  const splitNum = res.split(decimalChar);
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
  if (splitNum[1] !== "00") {
    res = splitNum.join(decimalChar);
  } else {
    res = splitNum[0];
  }
  return res;
};

const normalizePrice = (amount, decimals) => {
  const priceToShow = amount;
  if (!priceToShow && priceToShow !== 0) {
    return null;
  }
  if (!(typeof priceToShow === "number" || typeof priceToShow === "string")) {
    return null;
  }
  return parsePrice(priceToShow, decimals);
};

//layout: compact, default
//size: xl, l, m, s

// Enums
import { PRICE_LAYOUT, PRICE_SIZE, PRICE_DECORATION } from "./enums";

export { PRICE_LAYOUT, PRICE_SIZE, PRICE_DECORATION, PRICE_FONT_WEIGHT };

const setSizeProps = (layout, size) => {
  let priceSize = null;
  let currencySize = null;
  let quoteSize = null;

  switch (size) {
    case PRICE_SIZE.XXXL:
      priceSize = TEXT_SIZE.DISPLAY1; // Se reemplaza en el scss
      if (layout == PRICE_LAYOUT.COMPACT) {
        currencySize = TEXT_SIZE.DISPLAY1;
        quoteSize = TEXT_SIZE.TITLE3;
      } else {
        currencySize = TEXT_SIZE.DISPLAY1;
        quoteSize = TEXT_SIZE.DISPLAY1;
      }
      break;
    case PRICE_SIZE.XXL:
      priceSize = TEXT_SIZE.DISPLAY1;
      if (layout == PRICE_LAYOUT.COMPACT) {
        currencySize = TEXT_SIZE.TITLE4;
        quoteSize = TEXT_SIZE.CAPTION1;
      } else {
        currencySize = TEXT_SIZE.TITLE2;
        quoteSize = TEXT_SIZE.TITLE2;
      }
      break;
    case PRICE_SIZE.XL:
      priceSize = TEXT_SIZE.TITLE1;
      if (layout == PRICE_LAYOUT.COMPACT) {
        currencySize = TEXT_SIZE.TITLE6;
        quoteSize = TEXT_SIZE.CAPTION2;
      } else {
        currencySize = TEXT_SIZE.TITLE4;
        quoteSize = TEXT_SIZE.TITLE4;
      }
      break;
    case PRICE_SIZE.L:
      priceSize = TEXT_SIZE.TITLE2;
      if (layout == PRICE_LAYOUT.COMPACT) {
      currencySize = TEXT_SIZE.CAPTION1;
      quoteSize = TEXT_SIZE.CAPTION3;
      }
      else{
        currencySize = TEXT_SIZE.TITLE5;
        quoteSize = TEXT_SIZE.TITLE5;
      }
      break;
    case PRICE_SIZE.M_L:
      priceSize = TEXT_SIZE.TITLE4;
      currencySize = TEXT_SIZE.TITLE6;
      quoteSize = TEXT_SIZE.TITLE6;
      break;
    case PRICE_SIZE.L_M:
      priceSize = TEXT_SIZE.TITLE45,
      currencySize = TEXT_SIZE.TITLE6;
      quoteSize = TEXT_SIZE.TITLE6;
      break;
    case PRICE_SIZE.S:
      priceSize = TEXT_SIZE.CAPTION1;
      currencySize = TEXT_SIZE.CAPTION1;
      quoteSize = TEXT_SIZE.CAPTION1;
      break;
    case PRICE_SIZE.XS:
      priceSize = TEXT_SIZE.CAPTION2;
      currencySize = TEXT_SIZE.CAPTION2;
      quoteSize = TEXT_SIZE.CAPTION2;
      break;
    default:
    case PRICE_SIZE.M:
      priceSize = TEXT_SIZE.TITLE5;
      currencySize = TEXT_SIZE.TITLE5;
      quoteSize = TEXT_SIZE.TITLE5;
      break;
  }

  return {
    priceSize,
    currencySize,
    quoteSize,
  };
};

const Price = ({
  layout,
  size,
  color,
  price,
  currency,
  quote,
  decoration,
  fontType,
  segment: segmentProp,
  cyData,
  custoObjectInfo,
}) => {
  if (price < 0) {
    return null;
  }

  const priceToShow = normalizePrice(price, 2);

  let finalLayout = PRICE_LAYOUT.DEFAULT;
  let priceSize = null;
  let currencySize = null;
  let quoteSize = null;

  if (layout && Object.values(PRICE_LAYOUT).find((item) => item === layout)) {
    finalLayout = layout;
  }

  ({ priceSize, currencySize, quoteSize } = setSizeProps(finalLayout, size));

  const segment = getNormalizedSegment(segmentProp);
  let className = `price price-layout--${finalLayout} price-size--${size}`;
  if (custoObjectInfo) {
    className = `${className} custo-editable`
  }

  return (
    <div
      className={className}
      data-cy={cyData}
      onClick={custoObjectInfo ? () => custoObjectInfo.handler(custoObjectInfo.entryPoint) : null}   
    >
      <Text
        className="price--content"
        text={priceToShow}
        size={priceSize}
        color={color}
        cyData={cyData ? `${cyData}--content` : ''}
        display="inline"
        decoration={decoration}
        fontType={fontType}
        segment={segment}
      />
      <div className="price--unity">
        {currency && (
          <Text
            className="price--currency"
            text={currency}
            size={currencySize}
            color={color}
            cyData={cyData ? `${cyData}--currency` : ''}
            display="inline"
            decoration={decoration}
            fontType={fontType}
            segment={segment}
          />
        )}
        <div className="price--quote">
          {currency && quote && (
            <Text
              className="price--quote_text"
              text={`/${quote}`}
              cyData={cyData ? `${cyData}--quote_text` : ''}
              size={quoteSize}
              color={color}
              display="inline"
              decoration={decoration}
              fontType={fontType}
              segment={segment}
            />
          )}
        </div>
      </div>
    </div>
  );
};

Price.defaultProps = {
  size: PRICE_SIZE.M,
  decoration: PRICE_DECORATION.NONE,
  color: "grey6",
  fontType: PRICE_FONT_WEIGHT.REGULAR,
  custoObjectInfo: null,
  cyData: "",
};

export default Price;
